import { DashboardFilters } from '@/services/dashboard-filters.ts'
import { HttpService } from '@/services/http.ts'


export interface IngestMeta {
  first_transaction_date: string
  last_transaction_date: string
}

export interface BankSummary {
  id: string
  name: string
  logo: string
  users: number
  opportunities: number
  customers: number
  accounts_deposit: number
  accounts_loan: number
  ingest_meta: IngestMeta | null
}

export class BankApi {
  static async summary(): Promise<BankSummary> {
    const headers = {
      'Role': DashboardFilters.getCurrentRole().id
    }
    return HttpService.get<BankSummary>('/bank/summary/', headers)
  }
}
